export default __webpack_public_path__ + "static/media/pattern2.c01a5b5b.svg";